var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12467 11.9584L10.833 7.25008L9.64551 6.06258L6.12467 9.58341L4.37467 7.83341L3.18717 9.02091L6.12467 11.9584ZM6.99967 17.3334C5.06912 16.8473 3.47537 15.7397 2.21842 14.0105C0.96148 12.2813 0.333008 10.3612 0.333008 8.25008V3.16675L6.99967 0.666748L13.6663 3.16675V8.25008C13.6663 10.3612 13.0379 12.2813 11.7809 14.0105C10.524 15.7397 8.93023 16.8473 6.99967 17.3334ZM6.99967 15.5834C8.44412 15.1251 9.63856 14.2084 10.583 12.8334C11.5275 11.4584 11.9997 9.93064 11.9997 8.25008V4.31258L6.99967 2.43758L1.99967 4.31258V8.25008C1.99967 9.93064 2.4719 11.4584 3.41634 12.8334C4.36079 14.2084 5.55523 15.1251 6.99967 15.5834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/ShieldIcon.7daaf10facda8d58ae4244fceac5611d.svg";
export { ForwardRef as ReactComponent };